<template>
  <div>
    <v-card tile flat class="my-5">
      <v-card-text>
        <v-container>
          <h2 class="black--text">Pilih Pengawas</h2>
          <v-alert text color="blue" class="mt-2">
            <v-row>
              <v-col cols="12" lg="9">
                <p class="black--text mb-0 text-justify">
                  Silakan pilih daftar pengawas yang ada pada kota/kab daerah Anda, untuk menjadi peserta PKP 2. Perlu
                  diketahui bahwa data pengawas ini muncul berdasarkan data yang telah disinkronisasi dengan data
                  pengawas yang ada pada Sistem/Aplikasi SIMTENDIK
                </p>
              </v-col>
              <v-col cols="12" lg="3" class="text-right my-auto">
                <v-btn color="green" dark depressed @click="onCandidate">
                  <v-icon left>mdi-account</v-icon>Pilih Pengawas
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
          <div v-if="Object.keys(pengawas).length" class="mt-10">
            <template v-if="pengawas.nama_lain || !pengawas.ptk_id">
              <h2 class="black--text">Input Data Pengawas</h2>
              <p class="text-justify grey--text text--darken-1 body-2">
                Input data pengawas ini kondisi saat pengawas yang dimaksudkan tidak ditemukan di dalam listring
                pengawas yang ada. Sifatnya sebagai informasi tambahan saja, bukan sebagai pengawas yang bisa diset
                sebagai peserta PKP 2
              </p>
              <v-radio-group v-model="akun_ptk_aktif" row>
                <v-radio value="0">
                  <template v-slot:label>
                    <span class="black--text"><strong>Tidak mempunyai</strong>&nbsp;Akun SIMPKB</span>
                  </template>
                </v-radio>
                <v-radio value="1">
                  <template v-slot:label>
                    <span class="black--text"><strong>Mempunyai</strong>&nbsp;Akun SIMPKB</span>
                  </template>
                </v-radio>
              </v-radio-group>
              <div v-if="akun_ptk_aktif !== null">
                <template v-if="+akun_ptk_aktif === 1">
                  <v-row class="mb-10 mt-1">
                    <v-col cols="12" class="py-0">
                      <span class="px-0 body-2 grey--text" style="height: 24px">SIMPKB ID / Nomor UKG </span>
                    </v-col>
                    <v-col cols="12" lg="6" class="py-0">
                      <v-text-field
                        v-model="ptk_id_lookup"
                        :disabled="ptk_id_lookup_valid"
                        outlined
                        dense
                        hide-details
                        placeholder="Masukkan Nomor SIMPKB ID"
                      />
                    </v-col>
                    <v-col cols="12" lg="6" class="py-0 my-auto">
                      <v-btn v-if="!ptk_id_lookup_valid" depressed color="success" @click="onCheckAkun">Cek Akun</v-btn>
                      <v-btn v-else depressed dark color="red" @click="ptk_id_lookup_valid = false">Ganti Akun</v-btn>
                    </v-col>
                  </v-row>
                  <base-form-generator :schema="schema" v-model="pengawas"></base-form-generator>
                </template>
                <template v-else>
                  <div class="mt-5">
                    <base-form-generator :schema="schema" v-model="pengawas"></base-form-generator>
                  </div>
                </template>
              </div>
            </template>
            <template v-else>
              <h2 class="black--text">Pengawas yang Anda Pilih</h2>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-row no-gutters>
                    <v-col cols="12" md="5">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="blue">
                          <v-icon dark>mdi-account</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 px-1">
                          <v-list-item-title>
                            <v-label color="caption"><small>Nama Lengkap Pengawas</small></v-label>
                          </v-list-item-title>
                          <div class="blue--text body-1 font-weight-medium mb-0">
                            {{ pengawas.nama || $getDeepObj(pengawas, 'ptk.nama') }}
                          </div>
                          <div class="black--text">
                            <v-icon color="success" small dark left>
                              mdi-whatsapp
                            </v-icon>
                            <span class="body-2">{{ pengawas.no_hp || $getDeepObj(pengawas, 'ptk.no_hp') }}</span>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>SIMPKB ID / Nomor UKG</small></v-label>
                          </v-list-item-title>
                          <div class="link black--text body-2">
                            <div class="body-2">{{ pengawas.ptk_id }}</div>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Alamat Surel</small></v-label>
                          </v-list-item-title>
                          <div class="link black--text body-2">
                            <div>{{ pengawas.alt_email || $getDeepObj(pengawas, 'ptk.alt_email') || '-' }}</div>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </template>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
    <pengawas-kandidat ref="kandidat" />
  </div>
</template>

<script>
import PengawasKandidat from './Kandidat';
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import { mapActions } from 'vuex';

export default {
  components: { PengawasKandidat, BaseFormGenerator },
  data() {
    return {
      pengawas: {},
      akun_ptk_aktif: null,
      ptk_id_lookup: null,
      ptk_id_lookup_valid: false,
      loading: false,
    };
  },
  computed: {
    schema() {
      return [
        {
          exist: { status: +this.akun_ptk_aktif === 0 || (+this.akun_ptk_aktif === 1 && this.ptk_id_lookup_valid) },
          type: 'VTextField',
          name: 'nama_lain',
          label: 'Nama Pengawas',
          labelColor: 'grey',
          hint: 'wajib diisi',
          required: true,
          outlined: true,
          singleLine: true,
          dense: true,
          disabled: this.ptk_id_lookup_valid,
          grid: { cols: 12, md: 6, sm: 12 },
        },
        {
          exist: { status: +this.akun_ptk_aktif === 1 && this.ptk_id_lookup_valid },
          type: 'VTextField',
          name: 'ptk_id_lain',
          label: 'SIMPKB ID / Nomor UKG',
          labelColor: 'grey',
          hint: 'wajib diisi',
          required: true,
          outlined: true,
          singleLine: true,
          dense: true,
          disabled: true,
          grid: { cols: 12, md: 6, sm: 12 },
        },
        {
          exist: { status: +this.akun_ptk_aktif === 0 || (+this.akun_ptk_aktif === 1 && this.ptk_id_lookup_valid) },
          type: 'VTextField',
          name: 'no_wa',
          label: 'Nomor WhatsApp Aktif',
          labelColor: 'grey',
          hint: 'wajib diisi',
          required: true,
          outlined: true,
          singleLine: true,
          dense: true,
          disabled: +this.akun_ptk_aktif === 1 && !this.ptk_id_lookup_valid,
          grid: { cols: 12, md: 6, sm: 12 },
        },
        {
          exist: { status: +this.akun_ptk_aktif === 0 || (+this.akun_ptk_aktif === 1 && this.ptk_id_lookup_valid) },
          type: 'VTextField',
          name: 'email',
          label: 'Alamat Surel Aktif',
          labelColor: 'grey',
          hint: 'wajib diisi',
          required: true,
          outlined: true,
          singleLine: true,
          dense: true,
          disabled: +this.akun_ptk_aktif === 1 && !this.ptk_id_lookup_valid,
          grid: { cols: 12, md: 6, sm: 12 },
        },
      ];
    },
  },
  methods: {
    ...mapActions('dppPengawas', ['lookup']),

    reset(data) {
      this.pengawas = data;
      this.akun_ptk_aktif = null;
      this.ptk_id_lookup = null;
      this.ptk_id_lookup_valid = false;
      this.loading = false;

      if (data.ptk_id_lain) {
        this.akun_ptk_aktif = '1';
        this.$nextTick(() => {
          this.pengawas = data;
          this.pengawas.ptk_id = '';
          this.ptk_id_lookup = data.ptk_id_lain;
          this.ptk_id_lookup_valid = true;
        });
      } else if (this.pengawas.nama_lain) {
        this.akun_ptk_aktif = '0';
        this.$nextTick(() => {
          this.pengawas = data;
          this.pengawas.ptk_id = '';
        });
      } else {
        this.$nextTick(() => {
          this.pengawas = data;
        });
      }
    },

    getError() {
      if (
        (!this.pengawas.ptk_id && !this.pengawas.nama_lain) ||
        (+this.akun_ptk_aktif === 1 && !this.ptk_id_lookup_valid)
      ) {
        return 'Pastikan Anda telah memasukkan data pengawas';
      }

      return '';
    },

    getValue() {
      if (this.pengawas.ptk_id) {
        return { ptk_id: this.pengawas.ptk_id };
      }

      return this.pengawas;
    },

    onCandidate() {
      this.$refs.kandidat.open().then((resp) => {
        this.pengawas = resp || {};
      });
    },

    onCheckAkun() {
      const id = this.ptk_id_lookup || '';
      this.loading = true;
      this.lookup({ id }).then((resp) => {
        this.loading = false;
        this.ptk_id_lookup_valid = true;
        this.pengawas.nama_lain = this.$getDeepObj(resp, 'ptk.nama') || '';
        this.pengawas.ptk_id_lain = this.$getDeepObj(resp, 'ptk.ptk_id') || '';
        this.pengawas.no_wa = this.$getDeepObj(resp, 'ptk.no_hp') || '';
        this.pengawas.email = this.$getDeepObj(resp, 'ptk.alt_email') || '';
      });
    },

    onChangePtkNotFound() {
      this.ptk_id_lookup = null;
      this.ptk_id_lookup_valid = false;
      this.pengawas = { ptk_id: '', ptk_id_lain: '' };
    },
  },
  watch: {
    akun_ptk_aktif: 'onChangePtkNotFound',
  },
};
</script>

<style scoped>
>>> .v-list-item__content {
  flex: auto !important;
}
</style>
